import hero from '../img/hero/hero.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faInstagram,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';

const Hero = () => {
  return (
    <section id="hero" className="text-gray-600 body-font">
      <div
        className="
          container
          mx-auto
          flex
          px-5
          py-24
          md:flex-row
          flex-col
          items-center
        "
      >
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
          <img
            className="object-cover object-center rounded -mt-14"
            alt="hero"
            src={hero}
          />
        </div>
        <div
          className="
            lg:flex-grow
            md:w-1/2
            lg:pl-24
            md:pl-16
            flex flex-col
            md:items-start
            md:text-left
            items-center
            text-center
          "
        >
          <h1 className="title-font sm:text-5xl text-5xl mb-4">
            <u>Slice of Dreams</u>
          </h1>
          <div className="links text-3xl text-purple-600">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/slice_of_dreams_by_nasreen/"
              className="mr-5"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/Sliceofdream"
              className="mr-5"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://api.whatsapp.com/send?phone=8801787528206&fbclid=IwAR01s2WHplgjMUAny6_7p01yhyiYSJNeqsPyQJ_Scc9rXCx4eeYqdHkVUK4"
              className="mr-5"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
          </div>
          <p className="mb-8 mt-2 leading-relaxed text-lg">
            Slice of Dreams, is an online Cake Shop. We pride with delivering
            the cakes and jar cakes to you! All of our cakes are made fresh from
            scratch with every order.I'm a baker because I've dreamed of
            becoming a sugar connoisseur my entire life.
          </p>
          <div className="flex justify-center">
            <a
              href="#menu"
              className="
                inline-flex
                text-white
                bg-purple-500
                border-0
                py-2
                px-6
                focus:outline-none
                hover:bg-purple-600
                rounded
                text-lg
              "
            >
              See Menu
            </a>
            <a
              href="https://www.facebook.com/Sliceofdream"
              target="_blank"
              rel="noreferrer"
              className="
                ml-4
                inline-flex
                bg-gray-200
                border-0
                py-2
                px-6
                focus:outline-none
                hover:bg-gray-300
                rounded
                text-lg
              "
            >
              Order Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
